<template>
  <div class="project-template-left">
    <div class="title">
      <strong>{{ title }}</strong>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <div class="btn-list">
      <a-button-group>
        <a-button class="btn1" @click="$emit('lastClick')">上一步</a-button>
        <a-button type="primary" class="btn2" @click="$emit('nextClick')">
          {{ nextBtnText }}
        </a-button>
      </a-button-group>
    </div>
  </div>
</template>

<script>
import IconBack from '@comp/Icon/IconBack';
export default {
  name: 'ProjectTemplateLeft',
  components: { IconBack },
  props: {
    title: {
      type: String,
      default: '标题'
    },
    nextBtnText: {
      type: String,
      default: '下一步'
    }
  }
}
</script>

<style scoped lang="less">
.project-template-left {
  position: relative;
  min-width: 375px;
  max-width: 375px;
  border-left: 1px dashed rgba(255, 255, 255, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  overflow-y: auto;

  .title {
    position: relative;
    font-size: 18px;
    color: white;
    padding: 15px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);

    strong {
      display: block;
      padding-left: 20px;
    }
  }

  .back {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
  }

  .content {
    // padding: 0 20px;
    // padding:20px 0;
    padding: 20px;
    height: calc(100vh - 58px - 59px - 72px);
    overflow: auto
  }

  .footer {
    text-align: center;
  }

  .btn-list {
    padding: 20px 0;
    text-align: center;

    .btn1 {
      padding: 0 30px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border: none;
      border-radius: 21px 0 0 21px !important;
    }

    .btn2 {
      padding: 0 30px;
      color: white;
      background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
      border: none;
      border-radius: 0 21px 21px 0 !important;
    }
  }

}
</style>